import DateInput from "components/elements/DateInput";
import IconButton from "components/elements/IconButton";
import dataProvider from "core/DataProvider";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const NotificationAdd = props => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [periodFrom, setPeriodFrom] = useState("");
  const [periodTo, setPeriodTo] = useState("");
  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchClients();
  }, []);

  const submit = async () => {
    setLoading(true);
    try {
      const data = {
        title,
        description,
        period_from: periodFrom,
        period_to: periodTo,
        clients: selectedClients.map(x => x.value),
      };

      await dataProvider.network.post("notification", data);
      toast.success("Notification saved successfully");
      props.cancel();
    } catch (error) {
      console.error(error);
      toast.error("Failed to save notification");
    } finally {
      setLoading(false);
    }
  };

  const cancel = () => {
    props.cancel();
  };

  const fetchClients = async () => {
    setLoading(true);
    try {
      const data = await dataProvider.network.get("min-master/clients");
      const clients = data.map(x => ({ label: x.name, value: x.id }));
      setClients(clients);
    } catch (error) {
      toast.error("Failed to load clients");
    } finally {
      setLoading(false);
    }
  };

  const addClient = (client = null) => {
    if (!client) {
      setSelectedClients(clients);
    } else {
      setSelectedClients([client, ...selectedClients]);
    }
  };

  const removeClient = (index = null) => {
    if (!index) {
      setSelectedClients([]);
    } else {
      let clientList = [...selectedClients];
      clientList.splice(index, 1);
      setSelectedClients(clientList);
    }
  };

  const clientsToSelect = clients.filter(
    x => !selectedClients.map(x => x.value).includes(x.value)
  );

  let renderClientsToSelect = [];
  let renderSelectedClients = [];

  if (search.length >= 2) {
    const key = search.toLowerCase();
    renderClientsToSelect = clientsToSelect.filter(x =>
      x.label.toLowerCase().includes(key)
    );
    renderSelectedClients = selectedClients.filter(x =>
      x.label.toLowerCase().includes(key)
    );
  } else {
    renderClientsToSelect = clientsToSelect;
    renderSelectedClients = selectedClients;
  }

  return (
    <div className="notification-add">
      <div className="flex">
        <div className="flex right flex-v-center">
          {loading ? (
            <div className="loader">
              <div className="lds-hourglass"></div>
            </div>
          ) : (
            <>
              <IconButton
                icon="add"
                text="Save Notification"
                onClick={submit}
              />
              <IconButton text="Cancel" onClick={cancel} />
            </>
          )}
        </div>
      </div>
      <div className="box mtop">
        <div className="head pad-lr">
          <h3>Add Notification</h3>
        </div>
        <div className="prow flex mtop">
          <div className="flex flex-full flex-col">
            <div className="prow flex">
              <div className="el flex-full">
                <input
                  type="text"
                  value={title}
                  onChange={e => setTitle(e.target.value)}
                  placeholder="Title"
                />
              </div>
            </div>
            <div className="prow flex">
              <div className="el flex-full">
                <DateInput
                  value={periodFrom}
                  onChange={val => setPeriodFrom(val)}
                  placeholder="Period from"
                />
              </div>
              <div className="el flex-full">
                <DateInput
                  value={periodTo}
                  onChange={val => setPeriodTo(val)}
                  placeholder="Period to"
                />
              </div>
            </div>
          </div>
          <div className="flex flex-full">
            <textarea
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder="Description"
            ></textarea>
          </div>
        </div>
        <div className="selection pad-lr">
          <div className="mtop item-selector-wrapper">
            <div className="flex full-row flex-v-center">
              <div className="el">
                <h4>Clients</h4>
              </div>
              <div className="right">
                <div className="el">
                  <input
                    type="text"
                    onChange={e => setSearch(e.target.value)}
                    placeholder="Search"
                  />
                </div>
              </div>
            </div>
            <div className="flex mtop item-selector">
              <div className="flex flex-col col flex-full">
                <div className="el flex flex-v-center">
                  <div className="item-label bold">All</div>
                  <div className="item-action">
                    <IconButton icon="add" onClick={() => addClient()} />
                  </div>
                </div>
                {renderClientsToSelect.map((client, index) => (
                  <div
                    className="el flex item-row flex-v-center"
                    key={index}
                    onClick={() => addClient(client)}
                  >
                    <div className="item-label">{client.label}</div>
                    <div className="item-action">
                      <IconButton icon="add" />
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex flex-col col flex-full">
                <div className="el flex flex-v-center">
                  <div className="item-label bold">Selected</div>
                  <div className="item-action">
                    <IconButton icon="remove" onClick={() => removeClient()} />
                  </div>
                </div>
                {renderSelectedClients.map((client, index) => (
                  <div
                    className="el flex item-row flex-v-center"
                    key={index}
                    onClick={() => removeClient(index)}
                  >
                    <div className="item-label">{client.label}</div>
                    <div className="item-action">
                      <IconButton icon="remove" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationAdd;
